export type FileType = 'pdf' | 'csv' | 'xlsx'

export function exportFile(fileUrl: string) {
  const a = document.createElement('a');
  a.href = fileUrl;
  a.target = '_blank';
  
  document.body.appendChild(a);
  a.click();
  
  document.body.removeChild(a);
}